import UserMeModel                      from '@/models/services/fondations/UserMeModel';
import { AuthStore as WideskAuthStore } from '@widesk-core/stores/authStore.ts';
import { action }                       from 'mobx';
import { computed }                     from 'mobx';
import config                           from '@/config';
import cookie                           from '@widesk-core/tools/cookie';
import getAuthCookiePrefix              from '@/tools/authCookiePrefix';

class AuthStore extends WideskAuthStore {
	private _currentUser: UserMeModel | undefined;

	constructor() {
		super(cookie, getAuthCookiePrefix());

		// Onglet en impersonation : son token reste dans le sessionStorage
		try {
			if (sessionStorage.getItem(this.tokenKey)) {
				this.setStorage(sessionStorage);
			}
		} catch (e) {
			// sessionStorage indisponible
		}

		this._currentUser = this._currentUser || undefined;

		this.setRefreshTokenRequest(async () => {
			const refreshResponse = await fetch(config.api_endpoint + `/fondations/token/refresh`, {
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ refresh_token: this.refreshToken, from: 1 }),
			});

			const response = await refreshResponse.json();

			return { token: response.token, refreshToken: response.refresh_token };
		})
	}

	@action setCurrentUser(user: UserMeModel) {
		this._currentUser = user;
	}

	@computed get currentUser() {
		return this._currentUser as UserMeModel;
	}

	@computed
	public get isAuthenticated(): boolean {
		return !!this.token;
	}

	@computed
	public get isImpersonate(): boolean {
		return !!this.tokenData['impersonate.urn'];
	}

	/**
	 * Ouvre la session de l'utilisateur impersonné dans cet onglet uniquement (sessionStorage) :
	 * les cookies sont partagés avec les autres applications JTS (Fondations, RH, shop...),
	 * y écrire le token remplacerait la session de l'admin qui a lancé l'impersonation.
	 */
	public impersonate(token: string) {
		this.setStorage(sessionStorage);
		this.setToken('');
		this.setRefreshToken('');
		this.setToken(token);
	}

	public clear() {
		super.clear();
		const paths = ['/fr', '/en'];
		paths.forEach(path => {
			cookie.removeItem(this.tokenKey, { path: path });
			cookie.removeItem(this.refreshTokenKey, { path: path });
		})
	}

	public logout() {
		this.clear();
	}
}

export default new AuthStore();
